<template>
  <div @click="showField" class="exclude-outside-click cursor-pointer" :class="getClasses()">
    <div v-if="(customField.field_key == 'notes_research' || customField.field_key == 'project_detail' || customField.field_key == 'cap_communication') && ($router.currentRoute.name == 'projectDeliverable' || $router.currentRoute.name == 'calendar')" class="field-header">
      <div class="field-label" v-show="showLabel">{{ customField.label }}</div>
    </div>
    <div v-else>
      <label class="text-uppercase exclude-outside-click field-label p-0 cursor-pointer" v-show="showLabel">{{ customField.label }}</label>
    </div>
    <div class="text-field-wrap" v-if="customField.field_type == 'text'">
        <div class="text-field">
          <span class="exclude-outside-click edit-d-title" v-show="!editing">{{ customField.value ? customField.value : 'N/A' }}</span>
          <input @keyup.enter="editing = false" @blur="editing = false" ref="customInput" v-show="editing" v-click-outside="outside" :placeholder="customField.label" @change="updateProjectFieldValue(customField)" type="text" class="form-control" v-model="customField.value"/>
        </div>
    </div>
    <div class="text-field-wrap" v-if="customField.field_type == 'currency'">
        <div class="currency-field">
          <span class="exclude-outside-click edit-d-title" v-show="!editing">{{ customField.value ? formatPrice(customField.value) : '$0.00' }}</span>
          <b-input-group v-show="editing" v-click-outside="outside" prepend="$">
            <b-form-input @keyup.enter="editing = false" @blur="editing = false" ref="customInput" :placeholder="customField.label" @change="updateProjectFieldValue(customField)" type="text" v-model="customField.value"></b-form-input>
          </b-input-group>
        </div>
    </div>
    <div class="requisition-number-field-wrap" v-if="customField.field_type == 'requisition_number' && ($router.currentRoute.name == 'projectDeliverable' || $router.currentRoute.name == 'calendar')">
        <span class="exclude-outside-click edit-d-title" v-show="!editing">#{{ customField.value }}</span>
        <b-input-group v-show="editing" v-click-outside="outside" prepend="#">
          <b-form-input @keyup.enter="editing = false" @blur="editing = false" ref="customInput" :placeholder="customField.label" @change="updateProjectFieldValue(customField)" type="text" v-model="customField.value"></b-form-input>
        </b-input-group>
    </div>
    <div class="color-picker-field-wrap detail" v-if="customField.field_type == 'color_picker' && ($router.currentRoute.name == 'projectDeliverable' || $router.currentRoute.name == 'calendar')">
        <div class="text-field">
          <twitter-picker @input="customField.value = color; updateProjectFieldValue(customField)" v-model="color" />
        </div>
    </div>
    <div class="color-picker-field-wrap" v-if="customField.field_type == 'color_picker' && $router.currentRoute.name == 'project'">
        <div class="text-field">
          <span class="exclude-outside-click" v-show="!editing" style="padding: 5px 10px; border-radius: 10px;" :style="{background: customField.value ? customField.value : 'transparent', color: customField.value ? 'var(--wf-secondary)' : 'var(--hover-grey)'}">{{ customField.value ? customField.value : 'N/A' }}</span>
          <twitter-picker v-show="editing" v-click-outside="outside" @input="customField.value = color; updateProjectFieldValue(customField)" v-model="color" />
        </div>
    </div>
    <div class="text-field-wrap" v-if="customField.field_type == 'requisition_number' && ($router.currentRoute.name != 'projectDeliverable' && $router.currentRoute.name != 'calendar')">
        <div class="requisition_number-field text-field">
          <span class="exclude-outside-click edit-d-title" v-show="!editing">{{ customField.value ? customField.value : 'N/A' }}</span>
          <input @keyup.enter="editing = false" @blur="editing = false" ref="customInput" v-show="editing" v-click-outside="outside" :placeholder="customField.label" @change="updateProjectFieldValue(customField)" type="text" class="form-control" v-model="customField.value"/>
        </div>
    </div>
    <div v-if="customField.field_type == 'priority'">
        <div class="ml-0 priority-rating" @click="setPriority(customField)">
          <vue-star-rate
            :rateRange="customField.value ? Number(customField.value) : 0"
            :maxIcon="5"
            :iconHeight="17"
            :iconWidth="17"
            :hasCounter="false"
            :key="'del-priority-'+Math.random()+deliverable.id"
            iconColor="var(--wf-primary)"
            iconColorHover="var(--wf-primary)"
            iconShape="circle"
          ></vue-star-rate>
        </div>
    </div>
    <div
      ref="refDatepickerWrapper"
      class="datepicker-field-wrap field-wrap-datepicker"
      @click="findPosition()"
      v-if="customField.field_key == 'project_due_date'"
    >
      <span class="exclude-outside-click edit-d-title">
        <span
          class="exclude-outside-click"
          v-if="customField.value"
        >{{ customField.value | moment("DD MMM, YYYY") }}</span>
        <span class="exclude-outside-click" v-else>No Deadline</span>
      </span>
      <div class="custom-field">
        <vuejs-datepicker
          ref="customDatepicker"
          :format="customDateFormat"
          v-click-outside="outside"
          name="due_date"
          v-show="editing"
          v-model="customField.value"
          @input="updateProjectFieldValue(customField)"
          @selected="dateSelected=true"
          input-class="custom-datepicker form-control"
          :typeable="true"
        >
          <div slot="beforeCalendarHeader" class="calender-header">
            <b-button class="remove-dl-btn" variant="text" @click="resetDeadline">Remove Deadline</b-button>
            <b-button class="today-btn" variant="text" @click="onToday">Today</b-button>
          </div>

        </vuejs-datepicker>
      </div>
    </div>
    <div class="field-wrap" v-if="customField.field_type == 'wysiwyg'">
        <ckeditor
          editorUrl="/js/ckeditor/ckeditor.js"
          ref="customInput"
          v-model="customField.value"
          :id="'custom-field'"
          :config="editorConfig"
          @input="setChanged(customField, true)"
          @blur="checkChangedFieldValue(customField)"
          @ready="setChanged(customField, false)"
        ></ckeditor>
    </div>

    <div class="field-wrap" v-if="customField.field_type == 'textarea'">
      <span
        class="exclude-outside-click field-value text-hover-bg"
        v-show="!editing"  :title="customField.value"
        v-b-tooltip.hover
      >{{ customField.value || 'Click to set...' }}</span>
      <div class="custom-field">
        <textarea
          :rows="rows"
          ref="customInput"
          class="form-control custom-inputs"
          v-show="editing"
          v-click-outside="outside"
          @change="updateProjectFieldValue(customField)"
          @blur="editing = false"
          v-model="customField.value"
        />
      </div>
    </div>

    <div class="field-wrap" v-if="customField.field_type == 'project_coordinator'">
      <div class="info-bubbles cursor-pointer exclude-outside-click" v-if="projectCoordinator" @click="showAddCoordinator">
        <span
          v-show="!editing"
          v-for="(coordinator, index) in projectCoordinator"
          :title="coordinator.name"
          v-b-tooltip.hover.html
          class="initials badge badge-primary exclude-outside-click project-coordinator"
        >{{ coordinator.name | textInitials }}</span>
        <span v-show="!editing" v-if="projectCoordinator.length == 0" class="exclude-outside-click badge badge-gray project-coordinator">No Coordinator</span>
        <plus-button v-show="!editing" class="tagged-tags"/>
      </div>
      <div class="custom-field">
        <multiselect
          ref="projectCoordinator"
          v-click-outside="outside"
          v-model="projectCoordinator"
          :options="allUsers"
          :option-height="42"
          :show-labels="false"
          :multiple="true"
          label="name"
          track-by="id"
          v-show="editing"
          @close="editing=false"
          @input="setProjectCoordinator();"
        ></multiselect>
      </div>
    </div>

    <div class="field-wrap" v-if="customField.field_name == 'engagement_manager'">
      <div class="info-bubbles cursor-pointer exclude-outside-click"  @click="showAddEngagementManager">
        <span 
          v-if="engagementManager.id"
          :title="engagementManager.name"
          v-b-tooltip.hover.html 
          class="initials badge badge-primary exclude-outside-click project-coordinator"
          >{{(engagementManager.name) | textInitials}}</span>
          <plus-button v-show="!editing" class="tagged-tags"/>
      </div>
      <div class="custom-field">
        <multiselect
          ref="engagementManager"
          v-click-outside="outside"
          v-model="engagementManager"
          :options="allActiveUsers"
          :option-height="42"
          :show-labels="false"
          :multiple="false"
          :allow-empty="false"
          label="name"
          track-by="id"
          v-show="editing"
          @close="editing=false"
          @input="changeEngagementManager();"
        ></multiselect>
      </div>
    </div>
    <div class="field-wrap" v-if="customField.field_name == 'project_lead'"   @click="showAddProjectLead">
      <div class="info-bubbles cursor-pointer exclude-outside-click">
        <span 
          v-if="projectLead.id"
          :title="projectLead.name"
          v-b-tooltip.hover.html 
          class="initials badge badge-primary exclude-outside-click project-coordinator"
          >{{(projectLead.name) | textInitials}}</span>
          <plus-button v-show="!editing" class="tagged-tags"/>
      </div>
      <div class="custom-field">
        <multiselect
          ref="projectLead"
          v-click-outside="outside"
          v-model="projectLead"
          :options="allActiveUsers"
          :option-height="42"
          :show-labels="false"
          :multiple="false"
          :allow-empty="false"
          label="name"
          track-by="id"
          v-show="editing"
          @close="editing=false"
          @input="changeProjectLead();"
        ></multiselect>
      </div>
    </div>

    <div class="text-field-wrap" v-if="customField.field_type == 'select'">
      <div class="select-field">
      <span
        class="exclude-outside-click edit-d-title"
        v-show="!editing"
      >{{ customField.value || 'Click to set...' }}</span>
      <div class="custom-field">
        <multiselect
          ref="customInput"
          v-click-outside="outside"
          v-model="customField.value"
          :show-labels="false"
          :options="getOptions"
          :multiple="false"
          v-show="editing"
          @close="editing=false"
          @input="updateProjectFieldValue(customField); editing = false"
        ></multiselect>
      </div>
      </div>
    </div>

    <div class="field-wrap no-icon" v-if="customField.field_type == 'status'">
      <span
        v-if="customField.value"
        class="exclude-outside-click field-value status-field-value"
        :style="{ backgroundColor: parseValue(customField.value).color || customField.value.color }"

      >{{ parseValue(customField.value).name || customField.value.name }}</span>
      <span
        v-if="!customField.value"
        class="exclude-outside-click field-value"
        v-show="!editing"
      >Click to set...</span>
      <div class="custom-field status-field">
        <div class="custom-field-outside-bg-mobile" v-show="editing"></div>
        <multiselect
          ref="customInput"
          :searchable="false"
          v-show="editing"
          v-field-dismiss="outside"
          v-model="customField.value"
          :options="getOptions"
          @close="editing=false"
          @input="updateProjectFieldValue(customField);"
          @select="editing=false"
          :custom-label="customLabel"
          :show-labels="false">
          <template slot="option" slot-scope="props">
            <div :style="{ color: 'var(--wf-secondary)', borderRadius: '10px', backgroundColor: props.option.color, height: '40px', lineHeight: '40px', textAlign: 'center' }">{{ props.option.name }}</div>
          </template>
        </multiselect>
      </div>
    </div>


    <div class="field-wrap no-icon custom-field-users-wrapper" 
      v-if="customField.field_type == 'users' && isMultipleField">
      <div class="field-value exclude-outside-click">
        <div class="custom-field user-field custom-multiselect" v-show="editing">
            <multiselect
              ref="customInput"
              v-click-outside="outside"
              v-model="selectedUsers"
              :options="allActiveUsers"
              :show-labels="false"
              :close-on-select="false" 
              :multiple="isMultipleField"
              open-direction="bottom"
              label="name"
              track-by="id"
              @close="editing=false"
              @input="multipleUsersSelect"
            ></multiselect>
        </div>
        <span
            v-if="!selectedUsers || selectedUsers.length == 0"
            v-b-tooltip.hover
            title="Click to set..."
            class="exclude-outside-click field-value"
            style="display: inline-block"
          >Click to set...</span>
        <span class="info-bubbles" 
          v-if="selectedUsers && selectedUsers.length > 0"
          v-for="(sUser, index) in selectedUsers"
          :key="`${customField.field_key}-${index}`">
          <span
            v-if="sUser.name"
            v-b-tooltip.hover
            :title="(sUser && sUser.name) ? sUser.name : 'Click to set...'"
            class="exclude-outside-click field-value initials badge badge-primary"
            style="display: inline-block"
          > {{  (sUser.name) | textInitials }} </span>
          <span
            v-else
            v-b-tooltip.hover
            title="Click to set..."
            class="exclude-outside-click field-value"
            style="display: inline-block"
          > Click to set...</span>
        </span>
        <div class="add-multiselect-group" >
          <plus-button v-if="selectedUsers.length > 0" />
        </div>
      </div>
    </div>

    <span v-if="customField.field_type == 'file'">
      <input type="file" />
    </span>

    <span v-if="customField.field_type == 'radio'">
      <label
        class="ml-2"
        v-for="(radioValue, index) in parseValue(customField.value_set)"
        :key="'radio'+index"
      >
        <input
          @change="updateProjectFieldValue(customField)"
          type="radio"
          :value="radioValue"
          v-model="customField.value"
        />
        {{ radioValue }}
      </label>
    </span>

    <div class="last-updated last-updated-below" v-if="customField.field_type == 'wysiwyg' && customField.updated_at && updatedOnTop == false">
      Last updated {{ customField.updated_at | moment('MMM D HH:mm a') }}
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { Twitter } from 'vue-color'
import { mapActions, mapGetters } from "vuex";
import customStatusOptionPartial from "./StatusOptions";
import vueStarRate from "vue-js-star-rating";

export default {
  name: "CustomFields",
  // props: ["customField", "users", "showLabel"],
  props: {
    customField:Object,
    users: Array,
    showLabel: {
      type:Boolean,
      default: true
    },
    updatedOnTop: {
      type:Boolean,
      default: true
    },
    rows: {
      type:Number,
      default: 10
    },
    deliverable: Object
  },
  data() {
    return {
      color: 'var(--wf-tertiary)',
      projectCoordinator: [],
      projectLead: {},
      engagementManager: {},
      exclamationCircle: '',
      editing: false,
      dateSelected: false,
      changed:false,
      editorConfig: {
        toolbar:  [
          { name: 'document', groups: [ 'mode' ], items: [ 'Source' ] },
          { name: 'clipboard', groups: [ 'clipboard', 'undo' ], items: [ 'Cut', 'Copy', 'Paste', 'PasteText', '-', 'Undo', 'Redo' ] },                                        
          { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ], items: [ 'Bold', 'Italic', 'Underline', '-', 'RemoveFormat' ] },
          { name: 'paragraph', groups: [ 'list', 'blocks', 'align' ], items: [ 'NumberedList', 'BulletedList', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
          { name: 'links', items: [ 'Link', 'Unlink' ] },
          { name: 'insert', items: [ 'Image', 'Table', 'HorizontalRule' ] },
          { name: 'styles', items: [ 'Styles' ] },
          { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
          { name: 'tools', items: [ 'Maximize' ] }
        ],
      },
      selectedUsers: [],
    };
  },
  computed: {
    ...mapGetters(["allUsers", "allActiveUsers", "userAbilities", "allActiveUsers"]),
    _: function() {
      return _;
    },
    selectedUser: {
      get() {
        return this.allUsers.find(user => user.id == this.customField.value);
      },
      set(newValue) {
        this.customField.userName = newValue.name;
        this.customField.value = newValue.id;
      }
    },
    isMultipleField() {
      let isMultiple = false;
      const fieldExists = this.deliverable.projectCustomFields.find(field => field.field_key === this.customField.field_key);
      if (fieldExists) {
        isMultiple = fieldExists.is_multiple ? true : false;
      }
      return isMultiple;
    },
    getOptions() {
      if (this.customField) {
        if (this.customField.value_set) {
          let parsed = this.parseValue(this.customField.value_set);
          if (parsed == false) {
            return [];  // if we don't check for false... it thows up errors
          } else {
            // build value and text
            return parsed;
          }
        }
      }
      return [];
    },

    userCanEditProject() {
      const userId = localStorage.getItem("userId");
      const project = this.deliverable;

			if (this.userAbilities.accessAllProjects) {
				return this.userAbilities.editProject;
			}
			
			let isManager = false;
			if (project.engagement_manager instanceof Object) {
				isManager = userId == project.engagement_manager.id;
			} else {
				isManager = userId == project.engagement_manager;
			}

			return (this.userAbilities.editProject && isManager);
    },

    engagementManagerUsers() {
      // Hardcode
      const filteredUsers = this.allUsers.filter(x => x.userRoles.some(y => y.role_key == 'engagement_manager' || y.role_key == 'superadmin'));

      return filteredUsers;
    },
  },
  components: {
    "vuejs-datepicker": Datepicker,
    'twitter-picker': Twitter,
    vueStarRate
  },
  methods: {
    ...mapActions(["updateProjectFieldValue"]),
    showAddCoordinator() {
      this.editing = true
      this.$nextTick(() => {
        this.$refs.projectCoordinator.$el.focus()
      })
    },
    showAddEngagementManager() {
      if(!this.userCanEditProject) return;
      this.editing = true
      this.$nextTick(() => {
        this.$refs.engagementManager.$el.focus()
      })
    },
    showAddProjectLead() {
      if(!this.userCanEditProject) return;
      this.editing = true
      this.$nextTick(() => {
        this.$refs.projectLead.$el.focus()
      })
    },
    multipleUsersSelect(userArray) {
      let val = [];
      userArray.forEach(item => {
        val.push(item.id);
      });
      this.customField.value = val; // to hide click to set span
      let payload = {
        ...this.customField,
        field_id: this.customField.id,
        project_id: this.deliverable.id,
        id: null,
        value: val
      };
	    this.$store.commit("setIsDirty", true);
      this.updateProjectFieldValue(payload);
      this.editing = false;
    },
    formatPrice(value) {
        const rangeArray = value.split(/(\-|to)/g);

        if (rangeArray.length > 1) {
          for (let i in rangeArray) {
            rangeArray[i] = rangeArray[i].replaceAll(/\$/g, "");
            rangeArray[i] = rangeArray[i].trim();
          }

          let val1 = (rangeArray[0]/1).toFixed(2);
          let val2 = typeof rangeArray[1] == 'number' ? (rangeArray[1]/1).toFixed(2) : (rangeArray[2]/1).toFixed(2);

          if (isNaN(val1) || isNaN(val2)) {
          	return value;
            // return "0.00";
          }

          return val1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " - $" + val2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
          let valString = value.replaceAll(/\$/g, "");
          valString = valString.trim()
          let val = (valString/1).toFixed(2);

          // if (isNaN(val)) return "0.00";
          if (isNaN(val)) return value;

          return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
    },
    onToday() {
      this.customField.value = this.$moment().format("YYYY-MM-DD H:m:s");
      this.editing = false
      this.dateSelected = true
      this.$refs.customDatepicker.close();
	    this.$store.commit("setIsDirty", true);
      this.updateProjectFieldValue(this.customField);
    },
    resetDeadline() {
      this.customField.value = null;
      this.editing = false
      this.dateSelected = true
    },
    findPosition() {
      if (this.$refs.refDatepickerWrapper.getBoundingClientRect().y > 315) {
        $(".vdp-datepicker__calendar").css("top", "-282px");
      } else {
        $(".vdp-datepicker__calendar").css("top", "unset");
      }
    },
    setProjectCoordinator() {
      this.customField.value = this.projectCoordinator;
	    this.$store.commit("setIsDirty", true);
      this.updateProjectFieldValue(this.customField);
    },
    setPriority(customField) {
      let priority = $('.priority-rating .vue-star-rate ul.list li.active').length;
      customField.value = priority;
	    this.$store.commit("setIsDirty", true);
      this.updateProjectFieldValue(customField);
    },
    customLabel({ name }) {
      return name
    },
    checkChangedFieldValue(customField) {
      if (this.changed) {
        this.changed = false;
	      this.$store.commit("setIsDirty", true);
        this.updateProjectFieldValue(customField);
      }
    },
    setChanged(customField, isChanged) {
     	this.changed = isChanged;
    },
    getClasses() {
      let cl = "field-container";
        if (this.customField) {
          if(this.customField.field_key) {
            return " field-container--" + this.customField.field_key;
          }
        }
        return cl;
    },
    customDateFormat(date) {
      return this.$moment(date, "YYYY-MM-DD").format("DD MMM, YYYY");
    },
    parseValue(str) {
      try {
          return JSON.parse(str);
      } catch (e) {
          return false;
      }
    },
    showField() {
      if(!this.userCanEditProject) return;
      if (this.editing && this.customField.field_type == 'status') {
        this.editing = false;
        return;
      }
      if(this.editing && !this.dateSelected) return;
      this.editing = true;
      this.$nextTick(() => {
        if (typeof this.$refs.customInput != "undefined") {
          if(this.customField.field_type == 'wysiwyg') {
          } else {
            if (typeof this.$refs.customInput.quill != "undefined") {
              this.$refs.customInput.quill.focus();
            } else if (typeof this.$refs.customInput.$el != "undefined") {
              this.$refs.customInput.$el.focus();
            } else {
              this.$refs.customInput.focus();
            }
          }
        } else if(typeof this.$refs.customDatepicker != "undefined") {
          // this.$refs.customDatepicker.$children[0].$emit('showCalendar')
          if(!this.dateSelected) {
            this.$refs.customDatepicker.showCalendar()
            this.$refs.customDatepicker.$el.querySelector('input').focus()
          } else if(this.dateSelected) {
            this.dateSelected = false
            this.editing = false
          }

        }
      });
    },
    getStatuses(dataJson) {
      let data = this.parseValue(dataJson),
        options = [];
      data.forEach(status => {
        options.push(status.name)
      });
      return options;
    },
    outside() {
      this.editing = false
      this.dateSelected = false
    },

    changeProjectLead() {
      this.$store.dispatch("changeProjectLead", {project_lead: this.projectLead, id: this.deliverable.id});
    },
    changeEngagementManager() {
      this.$store.dispatch("changeProjectEngagementManager", {engagement_manager: this.engagementManager, id: this.deliverable.id})
    }
  },
  mounted() {
    if(this.customField.field_type == 'project_coordinator' && typeof this.customField.value == 'string') {
      this.projectCoordinator = JSON.parse(this.customField.value);
    }
    if(this.customField.field_type == 'color_picker') {
      let that = this;
      that.color = that.customField.value ? that.customField.value : 'var(--wf-tertiary)'
    }
    if(this.customField.field_name == 'project_lead') {
      this.projectLead = this.deliverable.project_lead;
    }
    if(this.customField.field_name == 'engagement_manager') {
      this.engagementManager = this.deliverable.engagement_manager;
    }
    let self = this;
    window.addEventListener("keyup", function(e) {
      if (e.keyCode === 27) {
        self.editing = false
        self.dateSelected = false
      }
    });
  },
  created() {
    if (this.customField) {
      if (this.customField.field_type == 'users') {
        const usersFields = this.deliverable.customFields.filter(field => field.field_key === this.customField.field_key);
        const alreadySelectedUsers = [];
        usersFields.forEach(item => {
          if (item.value) {
            let userInfo = this.allActiveUsers.find(user => user.id == item.value);
            if (userInfo) {
              alreadySelectedUsers.push(this.allActiveUsers.find(user => user.id == item.value));
            }
          }
        });
        if (alreadySelectedUsers.length > 0) {
          this.selectedUsers = alreadySelectedUsers;
          this.customField.value = alreadySelectedUsers;
        }
      }
    }
  },
};
</script>

<style>
.edit-deliverable-modal.edit-project-modal .field-header {
  border: unset;
  background: linear-gradient(to bottom, var(--wf-secondary) 0%, var(--edit-deliverable-modal-edit-project-modal-field-header-lgbg) 86%, var(--db-collapse-control-lgbg) 100%);
}
.edit-deliverable-modal.edit-project-modal .field-box .field-wrap {
  border: unset;
}
</style>